import {each}                 from 'lodash';
import { gsap }               from "gsap/dist/gsap";
import {x, x0} from '../_helpers';

export default class LoopText {

    constructor() {
        this.animations = [];
        this.init();
    }

    killAll() {
        each(this.animations, a => a.kill())
        this.animations = [];
    }

    update() {
        this.killAll();
        this.play();
    }

    play() {
        const elements = x('[js-text-loop]');
        const sepeedMultiplier = 12;
        each(elements, (el,i) => {
            const lineWidth = el.children[0].offsetWidth; 
            const duration = lineWidth/window.innerWidth*sepeedMultiplier;
            const direction = i%2 == 0 ? -1 : 1;
            const animation = gsap.to(el, {
                force3D: true,
                x: lineWidth*direction,
                duration: duration,
                ease: "none",
                repeat: -1
            });
            this.animations.push(animation);
        });
    }

    init() {
        this.play();
        window.addEventListener('resize', this.update.bind(this))
    }
}